/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseFieldViewer} from "./BaseFieldViewer";
import autobind from "autobind-decorator";
import {service as ProjectService} from "../../../Services/ProjectService";
import {StreamBankContext} from "../../../App/StreamBankContext";
import {StreamBankLink} from "../../../Components/Common/StreamBankLink";
import React from "react";

export class ProjectFieldViewer extends BaseFieldViewer {
	constructor(props) {
		super(props);

		this.setInitialState({
			project: null
		});
	}

	@autobind
	shouldReloadData(prevProps, prevState) {
		return this.props.Value != prevProps.Value;
	}

	@autobind
	loadData() {
		super.loadData();

		ProjectService.FindById(this.props.Value)
			.then((x) => {
				this.setState({project: x.result});
			});
	}

	@autobind
	getContext() {
		let context = new StreamBankContext();

		if (this.state.project) {
			context = new StreamBankContext(
				this.state.project.grandParentSlug,
				this.state.project.parentSlug,
				this.state.project.slug || this.state.project.projectId
			);
		}

		return context;
	}

	@autobind
	_render() {
		let context = this.getContext();

		return <StreamBankLink Context={context} Tool={"summary"} Disabled={this.state.project == null}>
			{this.state.project ? this.state.project.name : "N/A"}
		</StreamBankLink>;
	}
}